import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/axios";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setMessage("");
    setError("");
    setIsSubmitting(true);

    try {
      const res = await api.post("/auth/forgot-password", {
        email,
      });
      const data = res.data;
      if (res.status === 200) {
        setMessage(data.message || "Password reset link sent to your email.");
      } else {
        setError(data.message || "Something went wrong");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Server error. Try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="relative min-h-[calc(100vh-72px)] flex justify-center items-center bg-slate-950 px-4 py-10">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(37,99,235,0.35),_transparent_35%),radial-gradient(circle_at_bottom_right,_rgba(250,204,21,0.18),_transparent_30%)]" />
      <form
        onSubmit={handleSubmit}
        className="relative w-full max-w-md rounded-[2rem] border border-white/15 bg-slate-900/75 p-8 text-white shadow-2xl backdrop-blur-xl"
      >
        <p className="mx-auto mb-4 inline-flex rounded-full border border-cyan-300/35 bg-cyan-300/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-cyan-200">
          Password recovery
        </p>
        <h2 className="mb-2 text-center text-2xl font-bold text-white">Reset your password</h2>
        <p className="mb-5 text-center text-sm leading-6 text-slate-300">
          Enter the email linked to your account and we will send a secure reset link.
        </p>
        <label className="mb-2 block text-sm font-semibold text-slate-200">Email address</label>
        <input
          type="email"
          placeholder="name@example.com"
          className="mb-4 w-full rounded-xl border border-white/15 bg-white/5 p-3 text-white placeholder:text-slate-400 outline-none focus:ring-2 focus:ring-cyan-300/35"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button
          type="submit"
          disabled={isSubmitting}
          aria-busy={isSubmitting}
          className="w-full rounded-xl bg-accent py-3 font-semibold text-slate-950 transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {isSubmitting ? "Sending reset link…" : "Send reset link"}
        </button>
        {message && <p className="mt-3 rounded-xl border border-emerald-400/30 bg-emerald-500/10 px-3 py-2 text-sm text-emerald-200">{message}</p>}
        {error && <p className="mt-3 rounded-xl border border-red-400/30 bg-red-500/10 px-3 py-2 text-sm text-red-200">{error}</p>}
        <p className="mt-4 text-sm text-slate-300">
          Remembered it? <Link to="/login" className="font-semibold text-cyan-300">Sign in</Link>
        </p>
      </form>
    </div>
  );
}
